export default __webpack_public_path__ + "static/media/client-circle-icon.8e270fb6.png";